import styles from './Terminals.module.scss';
import PropTypes from 'prop-types';
import { sanitizePhoneNumber } from '../../utils/phone';
import OpeningHours from './OpeningHours';
import { useTranslation } from 'react-i18next';

const BookingInfoBlock = ({
    bookingInfo: {
        title,
        email,
        phoneCountryCode,
        phoneAreaCode,
        phone,
        openingHours,
        openingHoursText,
        notes,
    },
}) => {
    const { t } = useTranslation();
    const phoneNumber = `${phoneCountryCode} ${phoneAreaCode} ${phone}`;
    return (
        <div>
            <div className={styles.InfoSectionGroup}>
                {title && <p className={styles.InfoSectionName}>{title}</p>}
            </div>
            <OpeningHours hours={openingHours} openingHoursText={openingHoursText} />

            {phone || email ? (
                <div className={styles.InfoSectionGroup}>
                    <h3 className={styles.InfoSectionGroupHeader}>{t('terminals.contact')}</h3>
                    {phoneNumber && (
                        <a href={`tel:${sanitizePhoneNumber(phoneNumber)}`}>{phoneNumber}</a>
                    )}
                    {email && <a href={`mailto:${email}`}>{email}</a>}
                </div>
            ) : null}
            {notes && (
                <div className={styles.InfoSectionGroup}>
                    <h3 className={styles.InfoSectionGroupHeader}>
                        {t('terminals.furtherInformation')}
                    </h3>
                    <p>{notes}</p>
                </div>
            )}
        </div>
    );
};

const BookingInfo = ({ bookingInfo }) => {
    if (!bookingInfo?.length) {
        return null;
    }

    return (
        <div className={styles.InfoSection}>
            {bookingInfo.map((item, index) => (
                <BookingInfoBlock bookingInfo={item} key={index} />
            ))}
        </div>
    );
};

BookingInfo.propTypes = {
    bookingInfo: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            email: PropTypes.string,
            phoneCountryCode: PropTypes.string,
            phoneAreaCode: PropTypes.string,
            openingHours: PropTypes.arrayOf(
                PropTypes.shape({
                    text: PropTypes.string,
                    from: PropTypes.string,
                    until: PropTypes.string,
                })
            ),
        })
    ),
};

export default BookingInfo;
